import { PaginationProps } from 'components/semantic/PaginationState';
import { BaseSyntheticEvent } from 'react';
import { Button, Dropdown, Input, Pagination } from 'semantic-ui-react';
import styled from 'styled-components';

const EMPTY_SEARCH = '';

type Search = {
  categories: string[];
  onCategoryChange: (category: string) => void;
  onSearchChange: (searchTerm: string) => void;
  activePage: string | number;
  totalPages: number;
  onPageChange: (page: number) => void;
  selectedCategory: string;
  searchTerm: string;
};

const PaginationDiv = styled.div`
  margin-left: 20px;
  width: 400px;
`;

export function SearchPagination({
  onSearchChange,
  categories,
  activePage,
  totalPages,
  onPageChange,
  onCategoryChange,
  selectedCategory,
  searchTerm,
}: Search) {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: 400 }}>
        <Input
          fluid
          size="large"
          value={searchTerm}
          placeholder="Search ..."
          onChange={(e) => {
            const newValue = e.target.value;

            onSearchChange(newValue);
          }}
          label={
            <Dropdown
              value={selectedCategory}
              onChange={(e: BaseSyntheticEvent) => {
                const categoryName = e.target.textContent;
                onCategoryChange(categoryName);
              }}
              options={categories.map((cat) => ({ key: cat, value: cat, text: cat }))}
            />
          }
          action={<Button icon="times" disabled={!searchTerm || searchTerm === EMPTY_SEARCH} onClick={() => onSearchChange(EMPTY_SEARCH)} />}
        />
      </div>
      <PaginationDiv>
        {totalPages > 0 ? (
          <Pagination
            activePage={activePage}
            totalPages={totalPages}
            onPageChange={(_: any, paginationData: PaginationProps) => {
              onPageChange(Number(paginationData.activePage));
            }}
            firstItem={null}
            lastItem={null}
            pointing
          />
        ) : null}
      </PaginationDiv>
    </div>
  );
}
